export default {
  nome: {
    value: '',
    maxlength: '200',
    required: true,
    state: null
  },
  nomeFantasia: {
    value: '',
    maxlength: '200',
    required: false,
    state: null
  },
  cnpj: {
    value: '',
    maxlength: '50',
    required: false,
    state: null
  },
  ie: {
    value: '',
    maxlength: '50',
    required: false,
    state: null
  },
  codigoZ: {
    value: null,
    required: true,
    state: null
  },
  localidade: {
    value: '',
    maxlength: '50',
    required: false,
    state: null
  },
  selecionavel: {
    value: false,
    defaultValue: false,
    required: false,
    state: null
  },
  perfilAcessoID: {
    value: null,
    options: [],
    required: false,
    state: null
  },
  logo: {
    value: null,
    required: false,
    state: null
  },
  descricao: {
    value: '',
    maxlength: '500',
    required: false,
    rows: '3',
    noResize: true
  }
}



// WEBPACK FOOTER //
// ./src/views/private/configuration/company/company-form.js